export default __webpack_public_path__ + "static/media/ASSETS-15.4e1f6b23.png";